<script setup>
const props = defineProps({
  initial: {
    type: Object,
    required: true,
  },
})

const homepageHeroWidgetData = ref(props.initial)
</script>

<template>
  <div v-if="homepageHeroWidgetData" class="hero hero--seasonal">
    <div class="hero__main">
      <div class="hero__copy">
        <div v-if="$auth.loggedIn" class="hero__welcome">
          Welcome back, {{ $auth.user.first_name }}
        </div>
        <h1>
          <template v-if="homepageHeroWidgetData.headline_link">
            <a :href="homepageHeroWidgetData.cta_link">{{
              homepageHeroWidgetData.headline
            }}</a>
          </template>
          <template v-else>
            <strong>{{ homepageHeroWidgetData.headline }}</strong>
          </template>
        </h1>
        <div v-html="homepageHeroWidgetData.copy" />
      </div>
      <div class="hero__cta">
        <a :href="homepageHeroWidgetData.cta_link" class="longarrow-black">
          {{ homepageHeroWidgetData.cta_text }}
        </a>
      </div>
    </div>

    <div class="hero__img">
      <img
        :src="homepageHeroWidgetData.image_url"
        class="hero__img--desktop"
        alt=""
      />
      <img
        :src="homepageHeroWidgetData.image_url"
        class="hero__img--mobile"
        alt=""
      />
    </div>
  </div>
</template>
